(function () {
  function removeRetiredHomeBlocks(root) {
    var scope = root || document;
    var home = scope.querySelector && scope.querySelector('section.bcp-home');

    if (!home) {
      return;
    }

    var removableSelectors = [
      '.bcp-home__newsletter',
      '.bcp-home__faq',
      '.bcp-home__review-grid'
    ];

    removableSelectors.forEach(function (selector) {
      home.querySelectorAll(selector).forEach(function (node) {
        var wrapper = node.closest('.bcp-home__section') || node;
        wrapper.remove();
      });
    });

    home.querySelectorAll('h2').forEach(function (heading) {
      var text = heading.textContent.trim().replace(/\s+/g, ' ');

      if (
        text === 'Subscribe to our Emails' ||
        text === 'Answers to Your Questions' ||
        text === 'Loved by People Like You'
      ) {
        var wrapper = heading.closest('.bcp-home__section') || heading.parentElement;

        if (wrapper) {
          wrapper.remove();
        }
      }
    });
  }

  function injectCategoryStyles() {
    var style = document.getElementById('bcp-home-category-card-refresh-style');

    if (!style) {
      style = document.createElement('style');
      style.id = 'bcp-home-category-card-refresh-style';
      document.head.appendChild(style);
    }

    style.id = 'bcp-home-category-card-refresh-style';
    style.textContent = [
      'html body .bcp-home .bcp-home__collection-grid>.bcp-home__collection-card,html body .bcp-home__collection-card{display:flex!important;flex-direction:column!important;overflow:hidden!important;border:.1rem solid #dbe4ea;background:#fff;color:#1d2733;text-decoration:none;box-shadow:none;}',
      '.bcp-home__collection-media{aspect-ratio:1.22/1;display:grid;place-items:center;padding:1.4rem;background:linear-gradient(180deg,#f6f9fb 0%,#eef4f7 100%);}',
      '.bcp-home__collection-card .bcp-home__collection-media img{width:100%;height:100%;object-fit:contain;mix-blend-mode:multiply;}',
      '.bcp-home__collection-copy{display:flex!important;min-height:22rem!important;flex-direction:column;align-items:flex-start;gap:.9rem;padding:2rem 2rem 2.4rem;border-top:.1rem solid #dbe4ea;text-align:left;overflow:visible;}',
      '.bcp-home__collection-copy strong{color:#1d2733;font-family:Arial,Helvetica,sans-serif;font-size:clamp(1.8rem,1.45vw,2.2rem);font-weight:800;line-height:1.15;}',
      '.bcp-home__collection-copy p{margin:0;color:#748094;font-size:calc(var(--font-body-scale,1) * 1.35rem);line-height:1.45;}',
      '.bcp-home__collection-copy span,.bcp-home__collection-cta{display:inline-flex!important;align-items:center;justify-content:center;min-height:4.2rem!important;margin-top:auto!important;padding:1rem 1.5rem;border:.1rem solid #2f455c;background:#2f455c;color:#fff;font-size:calc(var(--font-body-scale,1) * 1.15rem);font-weight:800;line-height:1;text-transform:uppercase;white-space:nowrap;place-self:auto!important;}',
      '.bcp-home__collection-card:hover .bcp-home__collection-copy span{background:#1f3248;border-color:#1f3248;}',
      '.bcp-home__newsletter,.bcp-home__faq,.bcp-home__review-grid{display:none!important;}'
    ].join('');

  }

  function getCategoryCopy(label, index) {
    var normalized = (label || '').toLowerCase();
    var copies = [
      {
        match: /home|household|kitchen/,
        title: 'Home & Kitchen',
        note: 'Storage, cleaning, and daily helpers for an easier home.'
      },
      {
        match: /beauty|makeup/,
        title: 'Beauty Picks',
        note: 'Makeup and gift-ready finds for polished routines.'
      },
      {
        match: /tech|phone|mobile|accessor/,
        title: 'Tech Essentials',
        note: 'Chargers, stands, and compact accessories for daily use.'
      },
      {
        match: /car|auto|gadget/,
        title: 'Auto & Travel',
        note: 'Car tools and road-trip accessories made for convenience.'
      },
      {
        match: /toy|gift/,
        title: 'Toys & Gifts',
        note: 'Fun finds for kids, hobbies, and easy gifting.'
      }
    ];

    for (var i = 0; i < copies.length; i += 1) {
      if (copies[i].match.test(normalized)) {
        return copies[i];
      }
    }

    return copies[index] || {
      title: label || 'Shop Finds',
      note: 'Curated products picked for practical everyday use.'
    };
  }

  function refreshCurrentCategoryCards() {
    var home = document.querySelector('section.bcp-home');
    if (!home) {
      return false;
    }

    var heading = home.querySelector('.bcp-home__collection-grid') &&
      home.querySelector('.bcp-home__collection-grid').previousElementSibling;
    var cards = home.querySelectorAll('.bcp-home__collection-card');

    if (!cards.length) {
      removeRetiredHomeBlocks(document);
      return false;
    }

    injectCategoryStyles();
    removeRetiredHomeBlocks(document);

    if (heading) {
      var paragraph = heading.querySelector('p');
      if (paragraph) {
        paragraph.textContent = 'Browse the main shopping areas and jump straight into products that fit your daily routine.';
      }
    }

    cards.forEach(function (card, index) {
      if (card.querySelector('.bcp-home__collection-copy')) {
        return;
      }

      var media = card.querySelector('div');
      var oldTitle = card.querySelector(':scope > strong');
      var label = oldTitle ? oldTitle.textContent.trim() : '';
      var copy = getCategoryCopy(label, index);

      if (media) {
        media.classList.add('bcp-home__collection-media');
      }

      if (oldTitle) {
        oldTitle.remove();
      }

      var copyBlock = document.createElement('div');
      copyBlock.className = 'bcp-home__collection-copy';
      copyBlock.innerHTML = '<strong>' + copy.title + '</strong><p>' + copy.note + '</p><span class="bcp-home__collection-cta">Shop now</span>';
      card.appendChild(copyBlock);
      card.setAttribute('aria-label', 'Shop ' + copy.title);
    });

    document.documentElement.classList.add('bcp-home-category-cards-refreshed');
    return true;
  }

  if (refreshCurrentCategoryCards()) {
    return;
  }

  var legacyHome = document.querySelector('section.alwin-market');
  var currentHome = document.querySelector('section.bcp-home');

  if (!legacyHome || currentHome) {
    return;
  }

  var html = document.documentElement.innerHTML;
  var themeMatch = html.match(/\/cdn\/shop\/t\/(\d+)\//);
  var themeNumber = themeMatch ? themeMatch[1] : '';
  var previewThemeId = '187533852947';

  if (themeNumber === '59') {
    previewThemeId = '187309588755';
  } else if (themeNumber === '60') {
    previewThemeId = '187533852947';
  }

  var url = new URL(window.location.href);
  url.searchParams.set('preview_theme_id', previewThemeId);
  url.searchParams.set('bcp_home_refresh', Date.now().toString());

  fetch(url.toString(), { credentials: 'same-origin' })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Preview fetch failed');
      }
      return response.text();
    })
    .then(function (body) {
      var doc = new DOMParser().parseFromString(body, 'text/html');
      var refreshedHome = doc.querySelector('section.bcp-home');

      if (!refreshedHome) {
        return;
      }

      removeRetiredHomeBlocks(doc);
      legacyHome.replaceWith(refreshedHome);
      removeRetiredHomeBlocks(document);
      document.documentElement.classList.add('bcp-home-market-refreshed');
    })
    .catch(function () {
      legacyHome.classList.add('bcp-home-legacy-fallback');
    });
})();
